/* eslint-disable no-invalid-this */
/* eslint-disable func-style */
export function updateLocked(key) {
  const prop = `lockedPrevious_${key}`
  const overlayElem = this[key === 'hovered' ? 'Hovered' : 'Selected']
  const activeItem = this.getCanvasScope()[key]
  const locked =
    this.isReadOnly() ||
    activeItem?.state?.locked ||
    activeItem?.state?.content?.src
  if (this.data[prop] === locked) {
    return
  }
  this.data[prop] = locked
  if (locked) {
    overlayElem.setNodeStyles({
      ResizeOverlay: { display: 'none' },
      DragHandler: { display: 'none' }
    })
  } else {
    overlayElem.setNodeStyles({
      ResizeOverlay: { display: 'block' },
      DragHandler: { display: 'block' }
    })
  }
}
